import { IUserOrganization } from 'APIPackage/AuthModule/interfaces/IUserOrganization';
import { ORGANIZATION } from 'CorePackage/MainModule/constants/localStorageNames';

export const onSelectOrganization = (org: IUserOrganization) => {
  const { esiaOrgId: organizationId } = org;

  sessionStorage.setItem(ORGANIZATION, JSON.stringify(org));
  const href = organizationId
    ? `/esia-authentication-provider/api/esiaauth/login?org_id=${organizationId}`
    : '/esia-authentication-provider/api/esiaauth/login';

  window.location.href = window.location.origin + href;
};
